/* eslint-disable indent */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { Component, Input } from '@angular/core';
import * as _ from 'lodash';

@Component({
  selector: 'cargoes-common-form-details',
  templateUrl: './common-form-details.component.html',
  styleUrls: ['./common-form-details.component.less'],
})
export class CommonFormDetailsComponent {
  @Input() formData!: Map<string, any>;
  @Input() useTranslator =false;

  public columnCounter = 1;

  keepOrder = (a: any, b: any) => a;

  getLabelName(labelName: string): string {
    return _.startCase(labelName);
  }
}
